// extracted by mini-css-extract-plugin
export default {"AgentsMenu":"CopilotItems-module__AgentsMenu--zbZ2O","hasNotification":"CopilotItems-module__hasNotification--mRaxJ","CopilotMenu":"CopilotItems-module__CopilotMenu--OthpP"};